// extracted by mini-css-extract-plugin
module.exports = {"networkIndicator":"network-indicator_networkIndicator__3JTn3","container":"network-indicator_container__w--Ti"};